import http from 'plugins/axios';

export default {
  getTicketList(data) {
    return http.get({
      url: '/admin/question/search',
      data
    });
  },
  getTicketDetail(id) {
    return http.get({
      url: `/admin/question/detail/${id}`
    });
  },
  updateTicket({ id, status }) {
    return http.post({
      url: '/admin/question/update',
      data: {
        id,
        status
      },
      dataType: 'form'
    });
  }
};
